import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=a10e5166&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=a10e5166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e5166",
  null
  
)

export default component.exports